import { validationErrorMessages } from '../../utility/constants';
import { FormConfig } from '../../models/dynamic.model';
import { ValidatorPattern } from '../../utility/validators.pattern';

export const mailingAddressFormConfig: FormConfig = {
  fields: [
    {
      id: 'countryCode',
      type: 'select',
      label: 'Country',
      required: true,
      requiredError: 'Country is required',
    },
    {
      id: 'phone',
      type: 'input',
      label: 'Phone',
      noInitialWhiteSpace: true,
      required: false,
      requiredError: 'Phone Number is required',
    },
    {
      id: 'email',
      type: 'input',
      label: 'Email',
      required: false,
      pattern: ValidatorPattern.Email_Validator,
      noInitialWhiteSpace: true,
      maxValue: 50,
      requiredError: 'Email is required',
      emailPatternError: validationErrorMessages.invalidEmailEntered,
    },
    {
      id: 'name',
      type: 'input',
      label: 'Name',
      required: true,
      requiredError: 'Name is required',
      noInitialWhiteSpace: true,
      minValue: 1,
      maxValue: 126,
      maxLength: 126,
      isCheckForMaxValue: true,
      allowAlphabetWithSpace: true,
    },
    {
      id: 'companyName',
      type: 'input',
      label: 'Company Name',
      required: true,
      requiredError: 'Company Name is required',
      noInitialWhiteSpace: true,
      minValue: 1,
      maxValue: 126,
      maxLength: 126,
      isCheckForMaxValue: true,
      allowAlphabetWithSpace: true,
    },
    {
      id: 'address_1',
      type: 'input',
      label: 'Address Line 1',
      required: true,
      requiredError: 'Address Line 1 is required',
      noInitialWhiteSpace: true,
      maxValue: 126,
      isCheckForMaxValue: true,
    },
    {
      id: 'address_2',
      type: 'input',
      label: 'Address Line 2',
      required: false,
      noInitialWhiteSpace: true,
      maxValue: 126,
      isCheckForMaxValue: true,
    },
    {
      id: 'city',
      type: 'input',
      label: 'City',
      required: true,
      noInitialWhiteSpace: true,
      isCheckForMaxValue: true,
      requiredError: 'City is required',
      minValue: 3,
      maxValue: 50,
      minError: 'Invalid City entered',
    },
    {
      id: 'state',
      type: 'input',
      label: 'State/Province/Region',
      required: false,
      noInitialWhiteSpace: true,
      requiredError: 'State/Province/Region is required',
    },
    {
      id: 'zipCode',
      type: 'input',
      label: 'Postal Code',
      required: false,
      isCheckForMaxValue: true,
      noInitialWhiteSpace: true,
      minValue: 4,
      maxValue: 10,
      allowAlphaNumeric:true,
      minError: 'Postal code must be between 4 and 10 characters',
    },
    {
      id: 'contactPerson',
      type: 'input',
      label: 'Contact Person',
      required: false,
      noInitialWhiteSpace: true,
      minValue: 1,
      maxValue: 126,
      allowAlphabetWithSpace: true,
    },
  ],
};

type AddressHeader = {
  isSelected: boolean;
  key: string;
  defaultPrintWidth: number;
  label: string;
};

export const mailingAddressHeaders: AddressHeader[] = [
  {
    isSelected: true,
    key: 'countryCode',
    defaultPrintWidth: 100,
    label: 'Country Code',
  },
  {
    isSelected: true,
    key: 'phone',
    defaultPrintWidth: 120,
    label: 'Phone',
  },
  {
    isSelected: true,
    key: 'email',
    defaultPrintWidth: 150,
    label: 'Email',
  },
  {
    isSelected: true,
    key: 'name',
    defaultPrintWidth: 180,
    label: 'Name',
  },
  {
    isSelected: true,
    key: 'companyName',
    defaultPrintWidth: 120,
    label: 'Company Name',
  },
  {
    isSelected: true,
    key: 'address_1',
    defaultPrintWidth: 120,
    label: 'Address Line 1',
  },
  {
    isSelected: true,
    key: 'address_2',
    defaultPrintWidth: 120,
    label: 'Address Line 2',
  },
  {
    isSelected: true,
    key: 'city',
    defaultPrintWidth: 80,
    label: 'City',
  },
  {
    isSelected: true,
    key: 'state',
    defaultPrintWidth: 180,
    label: 'State/Province/Region',
  },
  {
    isSelected: true,
    key: 'zipCode',
    defaultPrintWidth: 120,
    label: 'Postal Code',
  },
  {
    isSelected: true,
    key: 'contactPerson',
    defaultPrintWidth: 150,
    label: 'Contact Person',
  },
];
